<template>
    <b-container fluid>
        <b-overlay :show='loading'>
            <iq-card>
                <template slot="body">
                    <b-row >
                        <b-col md="12" class="pt-3">
                            <h4>{{$t('externalUser.schedule')}}/{{$t('external_sidebar.routine')}}</h4>
                         <table class="table table-sm table-bordered">
                                <tr class="bg-primary">
                                    <th style="width: 30%">{{$t('externalUser.training_d')}}</th>
                                    <th>{{$t('externalUser.schedule')}}</th>
                                </tr>
                           <template v-if="formData.app_application.length">
                             <tr  v-for="(item, index) in formData.app_application" :key="index">
                               <td>
                                 {{$t('externalUser.fiscal_year')}}: {{EngBangNum(GetYear(item.circular.fiscal_year_id))}}
                                 <br>
                                 {{$t('externalUser.memo_no')}}: {{item.circular.circular_memo_no}}
                                 <br>
                                 {{$t('externalUser.training')}}: {{currentLocale === 'en'? item.training.training_title: item.training.training_title_bn}}
                                 <br>
                                 <span v-if="item.enroll">
                                                  {{$t('externalUser.batch')}}: {{currentLocale == 'en'? item.enroll.batch.batch_d.batch :item.enroll.batch.batch_d.batch_bn}}
                                              </span>
                               </td>
                               <td>
                                <template v-if="item.enroll">
                                  <table class="table table-sm table-bordered">
                                    <template v-if="item.enroll.batch && item.enroll.batch.routine.length > 0">
                                     <tr v-for="(item2, index2) in  item.enroll.batch.routine.find(x=> x.fiscal_year_id === item.circular.fiscal_year_id && x.circular_id === item.circular.id).routines" :key="index2">
                                        <td style="width: 20%">
                                          {{item2.training_date | dateFormat}}
                                        </td>
                                        <td>
                                          <table class="table table-sm table-borderless">
                                            <template v-if="item2.schedules">
                                              <tr v-for="(item3, index3) in item2.schedules" :key="index3">
                                                <td style="width: 32%">
                                                  {{new Date('1970-01-01T' + item3.start_time + 'Z')
                                                  .toLocaleTimeString(currentLocale+'-US',
                                                  {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
                                                  )}} - {{new Date('1970-01-01T' + item3.end_time + 'Z')
                                                  .toLocaleTimeString(currentLocale+'-US',
                                                  {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
                                                  )}}:
                                                </td>
                                                <td style="width: 68%">
                                                  {{item3.get_course ? currentLocale === 'en'? item3.get_course.name : item3.get_course.name_bn : item3.other_event}}
                                                   {{item3.get_trainer? currentLocale === 'en'? '('+ item3.get_trainer.name +')' : '('+ item3.get_trainer.name_bn +')' : ''}}
                                                </td>
                                              </tr>
                                            </template>
                                            <template v-else>
                                              <tr>
                                                <td colspan="3" class="text-center"> {{ (currentLocale == 'bn') ? 'তথ্য পাওয়া যায়নি' : 'Data not found' }}</td>
                                              </tr>
                                            </template>
                                          </table>
                                        </td>
                                      </tr>
                                    </template>
                                    <template v-else>
                                      <tr>
                                        <td colspan="2" class="text-center"> {{ (currentLocale == 'bn') ? 'তথ্য পাওয়া যায়নি' : 'Data not found' }}</td>
                                      </tr>
                                    </template>
                                  </table>
                                </template>
                                 <template v-else>
                              {{ (currentLocale == 'bn') ? 'তথ্য পাওয়া যায়নি' : 'Data not found' }}
                           </template>
                               </td>
                             </tr>
                           </template>
                           <template v-else>
                             <tr>
                               <td colspan="2" class="text-center"> {{ (currentLocale == 'bn') ? 'তথ্য পাওয়া যায়নি' : 'Data not found' }}</td>
                             </tr>
                           </template>
                            </table>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
        </b-overlay>
    </b-container>
</template>
<script>
    import { core } from '@/config/pluginInit'
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    import { ScheduleList } from '../../api/routes'

    export default {
        props: ['id'],
        components: {
        },
        created () {
            // this.checkRetailer()
            const userId = this.$store.state.Auth.authUser.id
            if (userId) {
                this.logged_user = userId
                this.getUserInfo(userId)
            }
        },
        mounted () {
            core.index()
        },
        data () {
            return {
               loading: false,
                logged_user: null,
                saved: false,
                isApproved: false,
                trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
                formData: []
            }
        },
        computed: {
          /*  loading () {
                return this.$store.state.ExternalUser.static.loading
            }, */
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
        },
        methods: {
            async getUserInfo (id) {
              this.loading = true
             //   this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: true })
                const result = await RestApi.getData(trainingElearningServiceBaseUrl, ScheduleList)
               // this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: false })
                if (result.success) {
                    this.formData = result.data
                } else {
                    //  this.$router.push({ name: 'external_user.stall_participant.profile_update' })
                }
                this.loading = false
            //  this.$store.dispatch('ExternalUser/mutateExternalFormLoad', { loading: false })
            },
            GetYear (id) {
                const list = this.$store.state.ExternalUser.commonObj.fiscalYearList.find(item => item.value === id)
                if (this.$i18n.locale === 'bn') {
                    return list.text_bn
                } else {
                    return list.text_en
                }
            },
          EngBangNum (n) {
            if (this.$i18n.locale === 'bn') {
              return n.replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d])
            } else {
              return n.replace(/[০-৯]/g, d => '০১২৩৪৫৬৭৮৯'.indexOf(d))
            }
          },
            GetTraining (id) {
                return id
             /*   const list = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === id)
                if (this.$i18n.locale === 'bn') {
                    return list.text_bn
                } else {
                    return list.text_en
                } */
            }
        }
    }
</script>
